export const TrainingTypes = {
    diplomantes: 'Diplômante',
    certifiantes: 'Certifiante',
    accelerees: 'Formation accélérée',
}